var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_79826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02656 14.6414H14.0067C14.3734 14.6414 14.6711 14.3437 14.6711 13.977V2.01681C14.6711 1.65003 14.3734 1.35238 14.0067 1.35238H8.02656C7.65913 1.35238 7.36213 1.05537 7.36213 0.687937C7.36213 0.3205 7.65913 0.0234375 8.02656 0.0234375H14.0067C15.1057 0.0234375 16 0.917813 16 2.01681V13.9769C16 15.0759 15.1057 15.9703 14.0067 15.9703H8.02656C7.65913 15.9703 7.36213 15.6733 7.36213 15.3058C7.36213 14.9384 7.65913 14.6414 8.02656 14.6414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.198195 7.52957L4.23807 3.54285C4.49854 3.28504 4.91979 3.28839 5.1776 3.54951C5.43541 3.81064 5.43276 4.23123 5.17095 4.48904L2.28391 7.3382H10.0201C10.3876 7.3382 10.6846 7.6352 10.6846 8.00264C10.6846 8.37007 10.3876 8.6671 10.0201 8.6671H2.28391L5.17095 11.5163C5.43273 11.7741 5.43473 12.1947 5.1776 12.4558C5.04738 12.5874 4.87595 12.6538 4.70451 12.6538C4.53573 12.6538 4.36698 12.59 4.23807 12.4624L0.198195 8.4757C0.0719452 8.35079 0.000195503 8.18067 0.000195503 8.0026C0.000195503 7.8246 0.0712891 7.65517 0.198195 7.52957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_79826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconWhite);
export default __webpack_public_path__ + "static/media/logout-icon-white.1923e3fe01759469ad546708a2e4aa4a.svg";
export { ForwardRef as ReactComponent };